let productList = [
  // 云播报
  [
    {
      isReverse: false,
      title: ['付帅收钱喇叭，不用手机，收钱听得到'],
      h4: [
        '特别推荐：快餐、烧烤、小吃店、便利店、小超市、',
        '社区商店等消费者到店消费的商家使用'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_b_01.png'
    },
    {
      isReverse: true,
      title: ['0.15秒急速播报，到账就报防漏单'],
      h4: [
        '物联网音箱播报比手机APP播报更快速稳',
        '定，到账即可播报无需客户出示付款',
        '记录，快速确认到账。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_b_02.png'
    },
    {
      isReverse: false,
      title: ['物联网音箱，手机不在也能播'],
      h4: [
        '脱离手机使用，手机不在店里也能播。不是',
        '蓝牙不是手机App监听，真正的物联网收',
        '款播报音箱！'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_b_03.png'
    },
    {
      isReverse: true,
      title: ['轻松拥有专业数据分析平台'],
      h4: [
        '拥有付帅云音箱，相当于拥有一支专业',
        '的分析团队轻松拥有专业数据平台，',
        '助你成功经营。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_b_04.png'
    },
  ],
  // 云打印
  [
    {
      isReverse: false,
      title: ['付帅云印神，随时随地，轻松打印'],
      h4: [
        '满足你的所有打印需求。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_01.png'
    },
    {
      isReverse: true,
      title: ['多种联网方式'],
      h4: [
        'WIFI+GPRS+蓝牙，多种联网方式，总有一种适合你。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_02.png'
    },
    {
      isReverse: false,
      title: ['一机多用，三头六臂'],
      h4: [
        '是热敏打印机，也是云打印机，还可以是收款音箱。',
        '打印机界的瑞士军刀。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_03.png'
    },
    {
      isReverse: true,
      title: ['多种供电模式'],
      h4: [
        '门店用220V（伏），餐车用12V（伏），外出用充电锂电池。',
        '我们竭尽全力，只因你特别需要。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_d_04.png'
    },
  ],
  // 其他设备
  [
    {
      isReverse: false,
      title: [
        '付帅云充宝，充电也是一门大生意'
      ],
      h4: [
        '付帅商户，可免费申请共享充电线，',
        '让充电，也能成为赚钱的大生意。'
      ],
      imgSrc: 'https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/hardware/hard_e_01.png'
    }
  ],
]

export default productList



// WEBPACK FOOTER //
// ./src/assets/conf/hardware.js